import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { formatPrettyDate, beautyTime } from '../utils';
import moment from 'moment';
var Event = function Event(props) {
  var nycjwEvent = props.nycjwEvent;
  var eventEndTime = nycjwEvent.end_time ? moment(nycjwEvent.end_time, ["h:mm A"]).format("HH:mm:ss") : moment('23:59:59', ["h:mm A"]).format("HH:mm:ss");
  var navigate = useNavigate();
  var params = useParams();
  var selectedTestDay = useSelector(function (state) {
    return state.selectedTestDay;
  });
  var todaysDate = useSelector(function (state) {
    return state.todaysDate;
  });
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    dateActive = _useState2[0],
    setDateActive = _useState2[1];
  var _useState3 = useState(params.type === 'virtual' ? 'Learn More' : 'RSVP'),
    _useState4 = _slicedToArray(_useState3, 2),
    buttonLabel = _useState4[0],
    setButtonlabel = _useState4[1];
  var _useState5 = useState(new Date()),
    _useState6 = _slicedToArray(_useState5, 2),
    today = _useState6[0],
    setToday = _useState6[1];
  var curEventType = params.type ? params.type : 'scheduled';
  var weekEndDate = new Date(eventIntros[eventIntros.length - 1]);
  weekEndDate.setDate(weekEndDate.getDate() + 1);
  useEffect(function () {
    if (selectedTestDay !== null) {
      setToday(new Date(selectedTestDay + " ".concat(today.getHours(), ":").concat(today.getMinutes(), ":").concat(today.getSeconds())));
    }
  }, [selectedTestDay, todaysDate]);
  useEffect(function () {
    setToday(selectedTestDay ? new Date(selectedTestDay + " ".concat(today.getHours(), ":").concat(today.getMinutes(), ":").concat(today.getSeconds())) : new Date());
  }, [nycjwEvent]);
  useEffect(function () {
    var eventStartDate = new Date(nycjwEvent.date + 'T09:00:00');
    var eventEndDate = new Date(nycjwEvent.date + 'T' + eventEndTime);
    var dateActiveText = today > eventStartDate ? 'event-active' : '';
    var buttonLabelText = buttonLabel;
    var ongoingStartTime = nycjwEvent.start_time ? moment(nycjwEvent.start_time, ["h:mm A"]).format("HH:mm:ss") : moment('07:00:00', ["h:mm A"]).format("HH:mm:ss");
    var eventDate = nycjwEvent.intro ? new Date(nycjwEvent.date + 'T23:59:59') : new Date(nycjwEvent.date + 'T' + ongoingStartTime);
    if (curEventType === 'one-time') {
      dateActiveText = '';
      var weekStartDate = new Date('2022-11-14T07:00:00');
      if (today >= eventDate) {
        buttonLabelText = 'Learn More';
      } else {
        buttonLabelText = nycjwEvent.listing_button_label ? nycjwEvent.listing_button_label : 'RSVP';
        if (!nycjwEvent.rsvp) {}
      }
    }
    if (today < eventDate && nycjwEvent.listing_button_label) {
      buttonLabelText = nycjwEvent.listing_button_label;
    }
    if (curEventType === 'on-going' || curEventType === 'virtual') {
      dateActiveText = '';
      if (nycjwEvent.start_date && nycjwEvent.start_date !== 'Invalid Date' || nycjwEvent.date) {
        var eventStartTime = nycjwEvent.start_time ? nycjwEvent.start_time : '06:00:00';
        // console.log(nycjwEvent, eventStartTime)
        eventStartDate = nycjwEvent.start_date ? new Date(nycjwEvent.start_date + 'T' + eventStartTime) : new Date(nycjwEvent.date + 'T' + eventStartTime);
        var _eventEndTime = nycjwEvent.end_time ? nycjwEvent.end_time : '11:59:00';
        eventEndDate = nycjwEvent.end_date ? new Date(nycjwEvent.end_date + 'T' + _eventEndTime) : new Date(nycjwEvent.start_date + 'T' + _eventEndTime);
      }
      if (nycjwEvent.dates) {
        var _eventStartTime = nycjwEvent.dates[0].start_time || '06:00:00';
        eventStartDate = new Date(nycjwEvent.dates[0].event_date + 'T' + _eventStartTime);
        var _eventEndTime2 = nycjwEvent.dates[nycjwEvent.dates.length - 1].end_time || '11:59:00';
        eventEndDate = new Date(nycjwEvent.dates[nycjwEvent.dates.length - 1].event_date + 'T' + _eventEndTime2);
      }
      if (curEventType === 'on-going') {
        if (today >= eventStartDate) {
          buttonLabelText = 'Learn More';
        } else {
          buttonLabelText = nycjwEvent.listing_button_label ? nycjwEvent.listing_button_label : 'Learn more';
        }
      }
      // console.group('EVENT')
      // console.log('today:', today)
      // console.log('start date: ', eventStartDate)
      // console.log('name:', nycjwEvent.title )
      // console.groupEnd()
      if (curEventType === 'virtual') {
        if (today >= eventStartDate) {
          buttonLabelText = 'watch now';
        } else {
          buttonLabelText = 'Learn More';
        }
      }
    }

    // If todays date is after the event end date
    if (today > eventEndDate && today < weekEndDate && params.type !== 'virtual') {
      dateActiveText = ' event-over';
    }
    setDateActive(dateActiveText);
    setButtonlabel(buttonLabelText);
  }, [today]);
  var borderColor = nycjwEvent.event_types ? nycjwEvent.event_types[0].color ? nycjwEvent.event_types[0].color : '#FEF200' : '#FEF200';
  var displayButton = true;
  var eventType = nycjwEvent.event_types ? nycjwEvent.event_types[0].name : null;
  var permalink = nycjwEvent.permalink.split('/');
  permalink = permalink[permalink.length - 1];
  var eventPermalink = nycjwEvent.supporting ? curEventType === 'virtual' ? params.cat === 'instagram' ? "/".concat(curEventType, "/instagram/").concat(permalink, "/").concat(nycjwEvent.supporting_permalink) : "/".concat(curEventType, "/").concat(permalink, "/").concat(nycjwEvent.supporting_permalink) : "/".concat(curEventType, "/").concat(params.cat, "/").concat(permalink, "/").concat(nycjwEvent.supporting_permalink) : curEventType === 'virtual' ? params.cat === 'instagram' ? "/".concat(curEventType, "/instagram/").concat(permalink) : "/".concat(curEventType, "/").concat(permalink) : "/".concat(curEventType, "/").concat(params.cat, "/").concat(permalink);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "event-listing".concat(dateActive).concat(nycjwEvent.intro ? ' intro' : '', " ").concat(nycjwEvent.scheduled_or_durational),
    onClick: function onClick() {
      return navigate({
        pathname: eventPermalink
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-image-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-image-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-image bg-centered",
    style: {
      backgroundImage: "url(".concat(nycjwEvent.listing_image, ")")
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "event-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-title"
  }, !nycjwEvent.intro && /*#__PURE__*/React.createElement("p", {
    className: "event-type"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      background: 'black',
      color: 'white'
    }
  }, nycjwEvent.virtual ? 'Virtual' : 'In-person'), eventType && /*#__PURE__*/React.createElement("span", {
    style: {
      background: borderColor,
      color: borderColor.toLowerCase() === '#fef200' || borderColor === 'rgb(255,255,0)' ? 'black' : 'white'
    }
  }, eventType)), /*#__PURE__*/React.createElement("h4", {
    dangerouslySetInnerHTML: {
      __html: nycjwEvent.title
    }
  }), nycjwEvent.subtitle && /*#__PURE__*/React.createElement("h5", {
    dangerouslySetInnerHTML: {
      __html: nycjwEvent.subtitle
    }
  }), nycjwEvent.excerpt && /*#__PURE__*/React.createElement("div", {
    className: "event-exc",
    dangerouslySetInnerHTML: {
      __html: nycjwEvent.excerpt
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "event-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-time",
    style: {
      'display': 'none'
    }
  }, nycjwEvent.date && !nycjwEvent.start_date && curEventType !== 'one-time' && /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'Bebas Neue'
    }
  }, formatPrettyDate(nycjwEvent.date)), nycjwEvent.dates && /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'Bebas Neue'
    }
  }, "".concat(formatPrettyDate(nycjwEvent.dates[0].event_date), " - ").concat(formatPrettyDate(nycjwEvent.dates[nycjwEvent.dates.length - 1].event_date))), nycjwEvent.start_date && !nycjwEvent.date && curEventType !== 'one-time' && /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'Bebas Neue'
    }
  }, formatPrettyDate(nycjwEvent.start_date), " ", nycjwEvent.end_date && " - ".concat(formatPrettyDate(nycjwEvent.end_date))), nycjwEvent.start_time && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0
    }
  }, nycjwEvent.start_time, nycjwEvent.end_time && /*#__PURE__*/React.createElement("span", null, " - "), nycjwEvent.end_time))), /*#__PURE__*/React.createElement("div", {
    className: "cta-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn",
    onClick: function onClick() {
      return navigate({
        pathname: eventPermalink
      });
    }
  }, buttonLabel))))));
};
export default Event;